import { applyMiddleware, createStore, Store } from "redux";
import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import reduxThunk from "redux-thunk";
import createReducer from "./reducers";
import { APP_NAME, APP_HOST } from "../config";
import history from "../config/history";
import { STORE_INITIAL_STATE } from "./store";

const { NODE_ENV } = process.env;

export default (): Store => {
  const middlewares = [routerMiddleware(history), reduxThunk];
  const enhancers = [applyMiddleware(...middlewares)];

  const composeEnhancers = composeWithDevTools({
    shouldHotReload: false,
    trace: NODE_ENV === "production" ? false : true,
    name: `${APP_NAME} [${APP_HOST}]`,
  });

  const store = createStore(
    createReducer(history),
    STORE_INITIAL_STATE,
    composeEnhancers(...enhancers),
  );

  return store;
};
